import React from 'react';

import type { Text } from '../../../../../../core/data-sources/content-components/types.js';

import { RichTextElement } from '../../../../helpers/rich-text.js';

type ListProps = {
  items: Text[];
  groupIndex?: number;
  id?: string;
};

const List: React.FC<ListProps> = ({ items, groupIndex }) => {
  return (
    <ul className="list">
      {items.map((item: Text, index) => (
        <li key={`item-${groupIndex}-${index}}`}>
          <RichTextElement content={item} />
        </li>
      ))}
    </ul>
  );
};

export default List;
